(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const sectionEl = document.querySelector('.product-recommendations');

  function loadProductRecommendations() {
    const { limit, url } = sectionEl.dataset;

    fetch(sectionEl.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const div = document.createElement('div');
        div.innerHTML = responseText;

        const rec = div.querySelector('.product-recommendations');
        if (rec && rec.innerHTML.trim().length) {
          document.querySelector('.product-recommendations').innerHTML = rec.innerHTML;
        }

        theme.initProductTitleAlignmentWatcher(sectionEl, '.productRecommendations');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (sectionEl.dataset.sectionId === e.detail.sectionId) {
      loadProductRecommendations();
    }
  });

  document.addEventListener('DOMContentLoaded', loadProductRecommendations);

  } catch(e) { console.error(e); }
})();

})();
